import { styled, css } from 'styled-components';
import { colors, getFontSize, getFontWeight } from '../../abstracts';
import { iconOnlyFigmaStyle, iconOnlyStyle, iconMargins } from '../../core-components/CoreButton/elements';
import { dontForwardProps } from '../../util';
const addWhiteToTheme = theme => ({
  ...theme,
  white: colors.white,
  whiteHover: colors.neutralBrighter,
  whitePressed: colors.neutralBright
});
const focusStyles = css(["&:focus{outline-width:0.125rem;outline-offset:0.25rem;}&:focus:not(:focus-visible){outline:none;}&:focus-visible{outline-width:0.125rem;outline-offset:0.25rem;}"]);
const smallButtonCss = css(["height:1.75rem;padding:0 1rem;"]);
const largeButtonCss = css(["height:3.75rem;padding:0 1.75rem;font-size:", ";"], getFontSize(3));
const getButtonSizeCss = size => {
  if (size === 'small') return smallButtonCss;
  if (size === 'large') return largeButtonCss;
  return undefined;
};
const getTypeDefaultCss = color => css(["&:not(.disabled){", " &:hover{background:", ";border-color:", ";}&:active{background:", ";border-color:", ";color:", ";}}&.disabled,&[aria-disabled='true']{background:", ";border-color:", ";}background:", ";border-color:", ";color:", ";"], focusStyles, ({
  theme
}) => addWhiteToTheme(theme)[`${color}Hover`], ({
  theme
}) => addWhiteToTheme(theme)[`${color}Hover`], ({
  theme
}) => addWhiteToTheme(theme)[`${color}Pressed`], ({
  theme
}) => addWhiteToTheme(theme)[`${color}Pressed`], ({
  theme
}) => ({
  primary: theme.textOnPrimary,
  secondary: theme.textOnSecondary,
  white: colors.black
})[color], colors.disabledBackground, colors.disabledBackground, ({
  theme
}) => addWhiteToTheme(theme)[color], ({
  theme
}) => addWhiteToTheme(theme)[color], ({
  theme
}) => ({
  primary: theme.textOnPrimary,
  secondary: theme.textOnSecondary,
  white: colors.black
})[color]);
const getTypeOutlineCss = color => css(["&:not(.disabled):not([aria-disabled='true']){", " &:hover{background:", ";}&:active{background:", ";border-color:", ";color:", ";}}&.disabled,&[aria-disabled='true']{border-color:", ";}background:transparent;color:", ";border:2px solid;border-color:", ";"], focusStyles, colors.neutralBrightest, colors.neutralBrighter, ({
  theme
}) => addWhiteToTheme(theme)[`${color}Pressed`], ({
  theme
}) => addWhiteToTheme(theme)[`${color}Pressed`], colors.disabledText, ({
  theme
}) => addWhiteToTheme(theme)[color], ({
  theme
}) => addWhiteToTheme(theme)[color]);
const getTypeFlatCss = color => css(["&:not(.disabled):not([aria-disabled='true']){", " &:hover{background:", ";border-color:", ";text-decoration:unset;}&:active{background:", ";border-color:", ";color:", ";}}color:", ";background:transparent;border-color:transparent;"], focusStyles, colors.neutralBrightest, colors.neutralBrightest, colors.neutralBrighter, colors.neutralBrighter, ({
  theme
}) => addWhiteToTheme(theme)[`${color}Pressed`], ({
  theme
}) => addWhiteToTheme(theme)[color]);
const getTypeTextCss = color => css(["&:not(.disabled):not([aria-disabled='true']){", " &:hover{color:", ";}&:active{color:", ";}}margin:0;padding:0;border:none;border-radius:1px;color:", ";text-decoration:underline;text-underline-position:under;background:inherit;height:initial;"], focusStyles, ({
  theme
}) => addWhiteToTheme(theme)[`${color}Hover`], ({
  theme
}) => addWhiteToTheme(theme)[`${color}Pressed`], ({
  theme
}) => addWhiteToTheme(theme)[color]);
export const getButtonVariantCss = (variant, color) => {
  switch (variant) {
    case 'default':
      return getTypeDefaultCss(color);
    case 'outline':
      return getTypeOutlineCss(color);
    case 'flat':
      return getTypeFlatCss(color);
    case 'text':
      return getTypeTextCss(color);
    default:
      return getTypeDefaultCss(color);
  }
};
const buttonPadding = ({
  $iconPresent,
  $iconSide,
  $btnSize
}) => {
  if (!$iconPresent) return '';
  if ($btnSize !== 'small') {
    return $iconSide === 'left' ? 'padding-left: 1.25rem' : 'padding-right: 1.25rem';
  } else {
    return $iconSide === 'left' ? 'padding-left: 0.75rem' : 'padding-right: 0.75rem';
  }
};
export const AnchorButtonVariant = styled.a.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1p2yoer-0"
})(["text-decoration:none;border-radius:10rem;font-family:inherit;font-weight:", ";font-style:normal;font-size:", ";height:2.75rem;display:flex;justify-content:center;align-items:center;border-style:solid;border-width:2px;letter-spacing:0;width:auto;text-align:center;white-space:nowrap;padding:0 1.75rem;&:hover:not(.disabled):hover:not([aria-disabled='true']){cursor:pointer;}", ";", ";", ";", " ", ";&.disabled,&[aria-disabled='true']{color:", ";-webkit-text-fill-color:", ";cursor:not-allowed;&:active,&:focus,&:focus-within,&:focus-visible{pointer-events:none;}}"], getFontWeight('base'), getFontSize(2), ({
  $btnSize
}) => getButtonSizeCss($btnSize), ({
  $btnVariant,
  $btnColor
}) => getButtonVariantCss($btnVariant, $btnColor), ({
  $iconPresent,
  $iconSide,
  $btnSize
}) => buttonPadding({
  $iconPresent,
  $iconSide,
  $btnSize
}), ({
  $childrenPresent,
  $btnSize,
  $useFigmaStyles
}) => {
  if (!$childrenPresent) {
    return $useFigmaStyles ? iconOnlyFigmaStyle[$btnSize] : iconOnlyStyle[$btnSize];
  }
}, ({
  $iconPresent,
  $btnVariant
}) => !$iconPresent && $btnVariant === 'flat' ? 'text-decoration: underline; text-underline-position: under;' : '', colors.disabledText, colors.disabledText);
export const BtnVariantIconWrapper = styled.div.withConfig({
  componentId: "aui__sc-1p2yoer-1"
})(["margin:", ";"], ({
  $childrenPresent,
  $iconSide,
  $size
}) => $childrenPresent ? $iconSide === 'left' ? iconMargins[$size].left : iconMargins[$size].right : '0');